import React from "react";

export default function Page({children}: any) {
  return <div className="page">{children}</div>;
}
